import React, { FC, useState } from "react";
import { Button, Card, Col, Flex, Modal, Row, Steps } from "antd";
import Info from "../../components/product/addAndEdit/Info";
import PriceOption from "../../components/product/addAndEdit/PriceOption";
import Stock from "../../components/product/addAndEdit/Stock";
import "../../styles/_switch.scss";
import "../../styles/_steps.scss";
import { useDispatch, useSelector } from "react-redux";
import { productType } from "../../types/product";
import { UploadFile } from "antd/lib";
import { useIntl } from "react-intl";

interface AddProductFormProps {
  visible: boolean;
  onClose: () => void;
}

const AddProductForm: FC<AddProductFormProps> = ({ visible, onClose }) => {
  const [current, setCurrent] = useState(0);
  const dispatch = useDispatch();

  const onNextStep = () => {
    setCurrent(current + 1);
  };

  const onCancel = () => {
    onClose();
  };
  const [product, setProduct] = useState<
    Omit<productType, "name"> & { name: { en: string; ar: string } }
  >({} as any);
  const [productImg, setProductImg] = useState<UploadFile>({
    uid: String(Math.random() + 9000),
    name: "productImg",
    url: "",
  });
  const intl = useIntl();
  const steps = [
    {
      sec_title: intl.formatMessage({ id: "team_work_info" }),
      title: intl.formatMessage({ id: "about_product" }),
      component: (
        <Info
          product={product}
          setProduct={setProduct}
          onNextStep={onNextStep}
          onClose={onCancel}
          productImg={productImg}
          setProductImg={setProductImg}
          update={false}
        />
      ),
    },
    {
      sec_title: intl.formatMessage({ id: "team_work_info" }),
      title: intl.formatMessage({ id: "product_pricing" }),
      component: (
        <Stock
          product={product}
          setProduct={setProduct}
          onNextStep={onNextStep}
          onClose={onCancel}
        />
      ),
    },
    {
      sec_title: intl.formatMessage({ id: "team_work_info" }),

      title: intl.formatMessage({ id: "product_inventory" }),
      component: (
        <PriceOption
          product={product}
          setProduct={setProduct}
          onClose={onClose}
          productImg={productImg}
        />
      ),
    },
  ];

  const onChange = (value: number) => {
    console.log("onChange:", value);
    if (current < value) {
      return;
    }
    setCurrent(value);
  };

  const currentStepComponent = steps[current].component;

  return (
    <Modal
      centered
      open={visible}
      onCancel={onCancel}
      okButtonProps={{ disabled: true }}
      cancelButtonProps={{ disabled: true }}
      footer={[]}
      width={1200}
      className="custom-modal" // Add a custom class here
    >
      <div className="mt-9 flex gap-8 flex  justify-center content-center">
        <div className="normalSteps min-w-[200px]">
          <Steps
            direction="vertical"
            current={current}
            items={steps}
            onChange={onChange}
            responsive={false}
            className="vertical-steps"
            style={{ height: "140%" }}
            size="small"
          />
        </div>
        <div className="w-full">
          <Card>
            <div className="text-color-primary text-2xl font-semibold leading-7 text-center">
              {intl.formatMessage({ id: "add_new_product" })}
            </div>
            {steps.map((step, index) =>
              current === index ? (
                <div
                  key={index}
                  className="my-4 text-color-gray text-base font-normal leading-7 text-center"
                >
                  {step.sec_title}
                </div>
              ) : null
            )}

            {currentStepComponent}
          </Card>
        </div>
      </div>
    </Modal>
  );
};

export default AddProductForm;
